// Ambang kuantil kecepatan buat mewarnai trail.

export const SPEED_COLORS = ['#1D4ED8', '#0EA5E9', '#10B981', '#F59E0B', '#EF4444'];

export function speedBuckets(speeds, jumlah = SPEED_COLORS.length) {
  const bersih = (speeds || [])
    .map(Number)
    .filter((v) => Number.isFinite(v))
    .sort((a, b) => a - b);
  if (bersih.length === 0) return [];
  const ambang = [];
  for (let i = 1; i < jumlah; i += 1) {
    ambang.push(bersih[Math.floor((bersih.length * i) / jumlah)]);
  }
  return ambang;
}

// Batas penuh tiap bucket: [terkecil, ...ambang, terbesar].
export function speedBounds(speeds, jumlah = SPEED_COLORS.length) {
  const bersih = (speeds || [])
    .map(Number)
    .filter((v) => Number.isFinite(v))
    .sort((a, b) => a - b);
  if (bersih.length === 0) return [];
  return [bersih[0], ...speedBuckets(bersih, jumlah), bersih[bersih.length - 1]];
}

// Label rentang satu bucket. Batas dan keluaran pakai satuan yang sama.
export function bucketLabel(i, batas) {
  if (!Array.isArray(batas) || batas.length < 2) return null;
  const j = Math.min(Math.max(i, 0), batas.length - 2);
  // Kapal lambat butuh dua angka; kalau enggak semua bucket kebaca sama.
  const desimal = Math.abs(batas[batas.length - 1]) < 10 ? 2 : 1;
  const f = (v) => Number(v).toFixed(desimal);
  return `${f(batas[j])} – ${f(batas[j + 1])}`;
}

export function bucketOf(speed, ambang) {
  const v = Number(speed);
  if (!Number.isFinite(v) || !ambang || ambang.length === 0) return 0;
  let i = 0;
  while (i < ambang.length && v >= ambang[i]) i += 1;
  return i;
}
